export default __webpack_public_path__ + "static/media/conta.2afec5cd.svg";